// packages/api-client/src/services/admin/imageStyles.ts
import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse, UUID, ImageStyle } from '@dopomogai/types';

const ADMIN_IMAGE_STYLES_PREFIX = '/admin/image-styles';

export const adminImageStylesService = {
  /**
   * Lists all available image styles for the admin dashboard.
   */
  listImageStyles: (): ServiceResponse<ImageStyle[]> => {
    return getApiClient().get<ImageStyle[]>(ADMIN_IMAGE_STYLES_PREFIX)
      .then(res => res.data)
      .catch(err => handleApiError(err, 'listing all image styles'));
  },

  /**
   * Retrieves a specific image style by ID.
   */
  getImageStyle: (styleId: UUID): ServiceResponse<ImageStyle> => {
    return getApiClient().get<ImageStyle>(`${ADMIN_IMAGE_STYLES_PREFIX}/${styleId}`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `getting image style ${styleId}`));
  },

  /**
   * Creates or updates an image style.
   */
  upsertImageStyle: (styleId: UUID, payload: ImageStyle): ServiceResponse<ImageStyle> => {
    return getApiClient().put<ImageStyle>(`${ADMIN_IMAGE_STYLES_PREFIX}/${styleId}`, payload)
      .then(res => res.data)
      .catch(err => handleApiError(err, `upserting image style ${styleId}`));
  },

  /**
   * Deletes an image style.
   */
  deleteImageStyle: (styleId: UUID): ServiceResponse<void> => {
    return getApiClient().delete<void>(`${ADMIN_IMAGE_STYLES_PREFIX}/${styleId}`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `deleting image style ${styleId}`));
  },
};